import React from 'react';

/**
 * Converts URLs in text to clickable links
 * Supports http, https, and www links
 */
export const linkifyText = (text, className = "text-blue-600 hover:text-blue-800 underline") => {
  if (!text) return text;
  
  // URL regex pattern - matches http, https, and www links
  const urlPattern = /(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi;
  
  const parts = text.split(urlPattern);
  
  return parts.map((part, index) => {
    // Check if this part is a URL
    if (part.match(urlPattern)) {
      // Add https:// if it starts with www.
      const href = part.startsWith('www.') ? `https://${part}` : part;
      return (
        <a
          key={index}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={className}
          onClick={(e) => e.stopPropagation()}
        >
          {part}
        </a>
      );
    }
    return part;
  });
};

/**
 * Component version of linkify for use in JSX
 */
export const LinkifyText = ({ children, className }) => {
  if (typeof children !== 'string') return children;
  return <>{linkifyText(children, className)}</>;
};

export default linkifyText;
